const module = { name: 'photos/gallery/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as gallery } from 'swug-fdRequire-call:photos/gallery/shared';



import { default as share } from 'swug-fdRequire-call:Fandango/share';



import { default as photoWall } from 'swug-fdRequire-call:photos/photoWall/shared';

function run() {
    checkDependencies(module.name, debugLog);
    gallery.init({ share });
    photoWall.init();
    gallery.run();
}
run();
export default module.exports;